import { AP_REGION_NAME, EU_REGION_NAME, US_REGION_NAME } from './constants';
/**
 * Utility to pull the region suffix in a URL out. Logic being that
 * the URL should be app.info360${-region}${-env}.com with no -region
 * for the US and no -region being treated as if it's prod
 * @returns
 */
export const getRegionSuffix = () => {
    const mockedRegion = localStorage.getItem('apiRegion');
    if (location.host.includes('autodesk.com')) {
        return '';
    }
    if (mockedRegion)
        return mockedRegion;
    if (!window.location.host)
        return '';
    if (!window.location.host.includes('info360'))
        return '';
    const splitHost = window.location.host.split('info360');
    const region = splitHost.length > 1 ? splitHost[1].split('.')[0].split('-')[1] : '';
    // Treat app.info360-prd.com like it's a normal prod site
    // Also determine which part is the region and which is the env
    if (splitHost[1].split('-').length < 3 &&
        (splitHost[1].includes('prd') ||
            splitHost[1].includes('dev') ||
            splitHost[1].includes('qa') ||
            splitHost[1] === '')) {
        return '';
    }
    return region;
};
export const getRegionName = () => {
    switch (getRegionSuffix()) {
        case 'eu':
            return EU_REGION_NAME;
        case 'ap':
            return AP_REGION_NAME;
        default:
            return US_REGION_NAME;
    }
};
